/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
// import LogoConlicitacaoDark from 'assets/images/logo-conlicitacao-dark.png';

import ExternalRoutes from 'services/external_routes';
import { profileSignIn } from 'store/modules/profile_store/actions';
import { getPanelProperties } from 'store/modules/panel_store/actions';
import tabId from 'services/tabId';
import { ProfileTypes } from 'store/modules/profile_store/types';
import { useLocation } from 'react-router-dom';
import * as S from './styles';

const LoginForm = () => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const { pathname } = useLocation();
  const afterSlash = pathname.split('/')[1];

  const dispatch = useDispatch();

  function handleLogin(event: any) {
    dispatch(profileSignIn({ login, senha: password, tabId: tabId() }));
    dispatch(getPanelProperties());
    dispatch({ type: ProfileTypes.VIEW_MODAL, modal: true });
    event.preventDefault();
  }

  useEffect(() => {
    dispatch(profileSignIn({ login, senha: password, refresh: true, tabId: tabId() }));
  }, []);

  return (
    <S.Fundo className="container-lg py-md-2">
      <div className="row justify-content-center">
        <div className="col-lg-6 align-content-lg-center">
          {afterSlash === 'signup=new' ? (
            <div className="text-center text-dark">
              <h3>Cadastro realizado com sucesso!</h3>
              <div className="card my-3 p-2 border border-primary message-card mx-5">
                <span>Seu cadastro está em validação e otimização.</span>
                <span>Você será avisado assim que o acesso estiver liberado.</span>
              </div>
            </div>
          ) : (
            <>
              <h4 className="text-center mb-4 font-weight-bold mt-4 mt-lg-0">Acessar sua conta</h4>
              <div className="text-center mb-3">
                <a href="/cadastro" className="btn btn-link text-secondary">
                  Ainda não tem uma conta?
                </a>
                <a href="/cadastro" className="btn btn-outline-primary font-weight-light">
                  Comece o teste grátis
                </a>
              </div>
            </>
          )}
          <div className="bg-white rounded shadow p-sm-5 col-md-12 mx-auto form-login">
            <form onSubmit={handleLogin} acceptCharset="UTF-8" target="_top" name="login">
              <S.Group>
                <label htmlFor="login">Seu e-mail</label>
                <input
                  value={login}
                  onChange={(e) => setLogin(e.target.value)}
                  type="email"
                  name="login"
                  id="login"
                  className="form-control"
                />
              </S.Group>
              <S.Group>
                <label htmlFor="senha">Sua senha</label>
                <input
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                  name="senha"
                  id="senha"
                  className="form-control"
                />
              </S.Group>
              <input
                type="submit"
                name="commit"
                value="Acessar"
                className="btn btn-primary btn-block btn-lg"
              />

              <div className="form-row mt-3">
                <div className="form-check form-check-inline col-md-6 col-12 m-0">
                  <label htmlFor="remember_me" className="form-check-label">
                    <input
                      type="checkbox"
                      value="true"
                      name="remember_me"
                      id="remember_me"
                      className="form-check-input"
                    />
                    Manter-me logado
                  </label>
                </div>
                <div className="form-group col-md-6 col-12 text-md-right text-left mb-0 mt-md-0 mt-3">
                  <a href={ExternalRoutes.login.esqueceu_senha}>Esqueceu a senha?</a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </S.Fundo>
  );
};

export default LoginForm;
